import styled, { css } from 'styled-components'

import { FlexCentered } from 'components/common/genericStyles'

export const Wrapper = styled.div`
    visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
    position: fixed;
    ${({ isQuizMode }) =>
        isQuizMode
            ? css`
                  display: flex;
              `
            : css`
                  display: grid;
                  grid-auto-flow: column;
              `};
    width: 100%;
    z-index: 12;
    padding: 5px 5%;
    justify-items: center;
    bottom: 0;
    left: 0;
    right: 0;
    margin-bottom: 2vh;
    max-width: 1000px;

    @media only screen and (orientation: landscape) {
        margin: auto;
        padding-right: 10%;
        direction: ltr;
        margin-bottom: 2vh;
    }
`

export const UtilsContainer = styled.div`
    ${FlexCentered}
`

export const OptionsWrapper = styled.div`
    display: flex;
    justify-content: space-around;
    ${({ areOptionsMinimized }) =>
        areOptionsMinimized
            ? css`
                  width: 0;
                  opacity: 0;
              `
            : css`
                  width: 100%;
                  opacity: 1;
              `}
    transition: width 0.5s, opacity 0.5s;
    overflow: hidden;
    margin: 0 0 0 auto;
`

export const MinimizeOptionsButton = styled.div`
    ${FlexCentered}
    flex-direction: row;
    justify-self: flex-end;
    padding: 12px 16px 12px 12px;
    background: #36383c;
    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.08),
        0px 4px 12px -4px rgba(0, 0, 0, 0.08);
    border-radius: 44px;
`

export const MinimizeOptionsButtonIcon = styled.img`
    margin-left: 8px;
`

export const MinimizeOptionsButtonArrow = styled.img`
    ${({ open }) =>
        open &&
        css`
            transform: rotate(180deg);
        `}
    transition: transform 0.5s;
    height: 50%;
`
